import React from 'react';
import { styled } from '@this/constants/themes';
import TranslateIgnoreText from '@this/components/shared/text/translate_ignore_text';
import type Trip from '@this/domain/trip/trip2';
import TransportElement from '@this/src/domain/transport_element2';
import {
  SectionDescText,
  OutlineBox,
  SectionApplication,
  SectionApplicationInfo,
  SectionLabel,
  SectionPrice,
  SectionBudgetHr,
  SectionDesc
} from './shared';

interface NonOrderItemsDescriptionProps {
  trip: Trip;
}

const SectionFlex = styled.div`
  display: flex;
  gap: 8px;

  & > *:first-child {
    min-width: 80px;
  }
`;

const NonOrderItemsDescription: React.FC<NonOrderItemsDescriptionProps> = ({ trip }) => {
  return (
    <>
      {trip.nonOrderItems.map((item, i) => (
        <SectionDesc key={item.id}>
          <OutlineBox>
            <SectionApplication>
              <SectionLabel>
                <p data-wovn-ignore>{`【経路${i + 1}】`}</p>
              </SectionLabel>
              <SectionApplicationInfo>
                <SectionDescText isOld={false}>
                  {item.elements.map(element => (
                    <SectionFlex key={element.id}>
                      <p data-wovn-ignore>
                        {element instanceof TransportElement && element.transportType !== 'other'
                          ? element.title
                          : '徒歩'}
                      </p>
                      <TranslateIgnoreText text={element.summary} />
                    </SectionFlex>
                  ))}
                  <p data-wovn-ignore>※表記は現地時刻です</p>
                </SectionDescText>
                <SectionBudgetHr />
                <SectionPrice>
                  <span>{item.typeStr}</span>
                  <span>{utils.digits(item.price.price)}円</span>
                </SectionPrice>
              </SectionApplicationInfo>
            </SectionApplication>
          </OutlineBox>
        </SectionDesc>
      ))}
    </>
  );
};

export default NonOrderItemsDescription;
export type { NonOrderItemsDescriptionProps };
